import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MessageSquare, ShieldCheck, Sparkles, CheckCircle2 } from 'lucide-react';

const LNCTA = () => {
  return (
    <section
      id="csi-cta"
      className="px-4 py-16 sm:px-6 lg:px-8 lg:py-24"
      style={{ backgroundColor: '#F8FAFC' }}
    >
      <div
        className="relative mx-auto max-w-7xl overflow-hidden rounded-3xl p-8 sm:p-12 lg:p-16 border"
        style={{
          background: 'linear-gradient(135deg, #0A1628 0%, #0F274A 50%, #173B70 100%)',
          borderColor: 'rgba(56, 189, 248, 0.3)',
          boxShadow: '0 24px 70px rgba(10, 22, 40, 0.35)',
        }}
      >
        {/* Ambient Glow Circles */}
        <div
          className="pointer-events-none absolute -left-20 -top-20 h-80 w-80 rounded-full blur-3xl"
          style={{ background: 'radial-gradient(circle, rgba(37, 99, 235, 0.3) 0%, transparent 70%)' }}
        />
        <div
          className="pointer-events-none absolute -right-20 -bottom-20 h-80 w-80 rounded-full blur-3xl"
          style={{ background: 'radial-gradient(circle, rgba(14, 165, 233, 0.25) 0%, transparent 70%)' }}
        />

        <div className="relative z-10 grid gap-10 lg:grid-cols-12 lg:items-center">
          {/* Content Column (8 cols) */}
          <div className="lg:col-span-8">
            <div
              className="mb-6 inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs font-semibold uppercase tracking-wider backdrop-blur-md"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                borderColor: 'rgba(56, 189, 248, 0.4)',
                color: '#38BDF8',
              }}
            >
              <Sparkles className="h-3.5 w-3.5" style={{ color: '#38BDF8' }} />
              <span>Strategic ERP Roadmap & Advisory</span>
            </div>

            <h2
              className="font-satoshi text-2xl font-bold leading-tight sm:text-3xl md:text-4xl"
              style={{ color: '#FFFFFF', fontFamily: "'Satoshi', sans-serif" }}
            >
              Ready to Accelerate Your Enterprise with Infor CSI?
            </h2>

            <p
              className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed font-normal"
              style={{ color: '#CBD5E1' }}
            >
              Connect with our certified Infor SyteLine architects for a structured readiness audit, 
              migration feasibility study, or live solution walkthrough tailored to your manufacturing cadence.
            </p>

            {/* Trust Highlights */}
            <div className="mt-8 flex flex-wrap items-center gap-6 text-xs sm:text-sm font-semibold" style={{ color: '#E2E8F0' }}>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4" style={{ color: '#38BDF8' }} />
                <span>Complimentary 45-Min Discovery Session</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4" style={{ color: '#38BDF8' }} />
                <span>Certified Infor Alliance Architects</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4" style={{ color: '#38BDF8' }} />
                <span>Enterprise NDA & IP Protection</span>
              </div>
            </div>
          </div>

          {/* Action Buttons Column (4 cols) */}
          <div className="lg:col-span-4 flex flex-col gap-4">
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <button
                type="button"
                className="group inline-flex w-full items-center justify-center gap-3 rounded-xl px-7 py-4 text-base font-bold transition-all duration-300 hover:shadow-2xl hover:-translate-y-0.5"
                style={{
                  backgroundColor: '#FFFFFF',
                  color: '#0A1628',
                  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.25)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#F8FAFC';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#FFFFFF';
                }}
              >
                <Calendar className="h-5 w-5" style={{ color: '#2563EB' }} />
                <span>Schedule an ERP Advisory Session</span>
              </button>
            </Link>

            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <button
                type="button"
                className="inline-flex w-full items-center justify-center gap-3 rounded-xl border px-7 py-4 text-base font-semibold backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',
                  borderColor: 'rgba(255, 255, 255, 0.25)',
                  color: '#FFFFFF',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.16)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
                }}
              >
                <MessageSquare className="h-5 w-5" style={{ color: '#38BDF8' }} />
                <span>Request Custom Briefing</span>
                <ArrowRight className="h-4 w-4" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LNCTA;
